<template>
  <div>
      <!-- 表格 -->
    <el-table
      :key="tableKey"
      ref="multipleTable"
      v-loading="listLoading"
      stripe
      :data="list"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column :show-overflow-tooltip="true" fixed label="收件人" min-width="100px">
        <template slot-scope="scope">
          <span>{{  emptyDeal(scope.row.recipients)}}</span>
        </template>
      </el-table-column>
      <el-table-column :show-overflow-tooltip="true" label="联系电话" min-width="100px">
        <template slot-scope="scope">{{ emptyDeal(scope.row.receivePhone) }}</template>
      </el-table-column>
      <el-table-column :show-overflow-tooltip="true" label="收件地址" min-width="100px">
        <template slot-scope="scope">{{ emptyDeal(scope.row.receiveAddress) }}</template>
      </el-table-column>
      <el-table-column :show-overflow-tooltip="true" label="所属产品线" min-width="100px">
        <template slot-scope="scope">{{  getApp(scope.row.appId) }}</template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { statusTrans, emptyTrans, sortDataList } from '@/api/dataTrans.js'
import {reciveList,getSystem} from "@/api/system"
export default {

  props: ['userId'],
  data() {
    return {
     list:[],
     listLoading: false,
      tableKey: 0,
      systemList:[]
    }
  },
  mounted() {
     this.getSystemList()
     this.fetchData()
  },
  methods: {
    emptyDeal(_val) {
      return emptyTrans(_val)
    },
    fetchData(){
      reciveList({
        userId:this.userId
      }).then(res=>{
        if(res&&res.code==0){
           this.list=res.data
        }
      })
    },
     // 获取应用
    getApp(data) {
      for(var i =0;i<this.systemList.length;i++){
        if(this.systemList[i].id==data){
           return this.systemList[i].name
        }
      }
    },
    //获取所有系统
    getSystemList(){
      getSystem({
        pageNo:1,
        pageSize:1000
      }).then(res=>{

      if(res&&res.code==0){
          this.systemList=res.data.items
        }
        
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.el-col-22 {
  border-top: 1px solid rgba(0, 0, 0, 0.05);
}
.header {
  position: relative;
  top: -8px;
  right: -12px;
  font-size: 14px;
  color: #000;
  font-weight: 600;
}
select {
  outline: none;
}
/deep/.distpicker-address-wrapper select {
  font-size: 14px;
  height: 30px;
  padding: 5px 12px;
  border-radius: 0px;
  outline: none;
}
/deep/.distpicker-address-wrapper select:focus {
  border: 1px solid #FFA940 !important;
  outline: none;
}

/deep/.distpicker-address-wrapper select:active {
  border: 1px solid #FFA940 !important;
  outline: none;
}
/deep/.distpicker-address-wrapper select option:hover {
  background: #FFA940 !important;
  background-color: #FFA940 !important;
  outline: none;
}

/deep/.distpicker-address-wrapper select option {
  border: 1px solid #FFA940;
  outline: none;
}
/deep/.distpicker-address-wrapper select option:focus,
.distpicker-address-wrapper select option:active {
  border: 1px solid #FFA940;
  outline: none;
}
.el-col-24 {
  border-top: 1px solid #e8e8e8;
  padding-top: 8px;
  text-align: right;
}
</style>
